import type { ReactNode } from 'react';
import './page-hero.css';

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
  illustration?: 'skyline';
  size?: 'regular' | 'compact';
}

export function PageHero({ eyebrow, title, description, children, illustration, size = 'regular' }: PageHeroProps) {
  return <section className={`page-hero page-hero--${size}${illustration ? ` page-hero--${illustration}` : ''}`}>
    <div className="page-hero-content">
      {eyebrow && <p className="page-hero-eyebrow">{eyebrow}</p>}
      <h1>{title}</h1>
      {description && <p className="page-hero-description">{description}</p>}
      {children}
    </div>
    {illustration === 'skyline' && <svg className="page-hero-skyline" viewBox="0 0 460 230" aria-hidden="true" focusable="false">
      <path d="M0 178h46v-23h31v23h27V97l24-12 24 12v81h20V64l28-13 28 13v114h47v-54h24v54h34v-22h42v22h85v52H0z" />
    </svg>}
  </section>;
}
